'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dHome$002dPage$0024 from "./presto.-Home-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002449 from "./presto.-Presto-Router$$anon$49.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$48() {
  this.bjg = null;
  this.bj8 = null;
  this.bj9 = false;
  this.bjh = null;
  this.bji = false;
  this.bjl = null;
  this.bje = null;
  this.bjf = false;
  this.bja = null;
  this.bjb = false;
  this.bjc = null;
  this.bjd = false;
  this.bjj = false;
  this.bjk = false;
  this.bjg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bjl = "HomePage";
}
export { $c_Lpresto_PrestoRouter$$anon$48 as $c_Lpresto_PrestoRouter$$anon$48 };
$p = $c_Lpresto_PrestoRouter$$anon$48.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$48;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$48() {
}
export { $h_Lpresto_PrestoRouter$$anon$48 as $h_Lpresto_PrestoRouter$$anon$48 };
$h_Lpresto_PrestoRouter$$anon$48.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bjg;
});
$p.L = (function() {
  if ((!this.bj9)) {
    this.bj8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bj9 = true;
  }
  return this.bj8;
});
$p.O = (function() {
  if ((!this.bji)) {
    this.bjh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bji = true;
  }
  return this.bjh;
});
$p.E = (function() {
  return this.bjl;
});
$p.t = (function() {
  if ((!this.bjf)) {
    this.bje = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjf = true;
  }
  return this.bje;
});
$p.M = (function() {
  if ((!this.bjb)) {
    this.bja = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjb = true;
  }
  return this.bja;
});
$p.Q = (function() {
  if ((!this.bjd)) {
    this.bjc = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002449.$c_Lpresto_PrestoRouter$$anon$49();
    this.bjd = true;
  }
  return this.bjc;
});
$p.w = (function() {
  if ((!this.bjk)) {
    this.bjj = false;
    this.bjk = true;
  }
  return this.bjj;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee384) => ((p) => \u03b4scrutinee384))($j_presto$002e$002dHome$002dPage$0024.$m_Lpresto_HomePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$48 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$48, "presto.PrestoRouter$$anon$48", ({
  Of: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$48 as $d_Lpresto_PrestoRouter$$anon$48 };
//# sourceMappingURL=presto.-Presto-Router$$anon$48.js.map
